module.exports = __webpack_public_path__ + "img/ruler-vertical.99be7c29.svg";